import axios from "axios";

export function getTrainingSessionTpl(s: string = '') {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl';
    const params = [];
    if (s.length > 0) {
        params.push('s=' + s);
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function getTrainingSessionTplOptions() {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl/options';
    return axios.get(endpointUrl, { headers: headers } );
}

export function getTrainingSessionTplSingle(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const getEventsUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl/' + id;
    return axios.get(getEventsUrl, { headers: headers } );
}

export function createTrainingSessionTpl(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function cloneTrainingSessionTpl(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl-clone';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}


export function updateTrainingSessionTpl(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl';
    return axios.patch(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function deleteTrainingSessionTpl(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}

/* Fases */
export function getTrainingSessionTplPhaseSingle(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const getEventsUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl-phase/' + id;
    return axios.get(getEventsUrl, { headers: headers } );
}

export function createTrainingSessionTplPhase(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl-phase';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function cloneTrainingSessionTplPhase(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl-phase-clone';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function sortUpTrainingSessionTplPhase(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl-phase-sort-up';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function sortDownTrainingSessionTplPhase(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl-phase-sort-down';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateTrainingSessionTplPhase(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl-phase';
    return axios.patch(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateTrainingSessionTplPhaseVideos(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl-phase-videos';
    return axios.patch(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function deleteTrainingSessionTplPhase(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl-phase/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}

/* Exercises */
export function getTrainingSessionTplExerciseSingle(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const getEventsUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl-exercise/' + id;
    return axios.get(getEventsUrl, { headers: headers } );
}

export function createTrainingSessionTplExercise(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl-exercise';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function cloneTrainingSessionTplExercise(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl-exercise-clone';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function sortUpTrainingSessionTplExercise(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl-exercise-up';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function sortDownTrainingSessionTplExercise(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl-exercise-down';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateTrainingSessionTplExercise(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl-exercise';
    return axios.patch(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateTrainingSessionTplExerciseVideos(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl-exercise-videos';
    return axios.patch(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function deleteTrainingSessionTplExercise(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/training-session-tpl-exercise/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}